import React from "react"
import * as styles from "./index.module.less"

const AddOns = ({ data }) => {
  const {
    sectionTitle,
    description,
    feature1,
    feature2,
    feature3,
    feature4,
    feature5,
    feature6,
  } = data
  return (
    <div className="container overflow-hidden">
      <div className={styles.add_ons_container}>
        <h2 className="text-md-center">{sectionTitle}</h2>
        <p className="text-md-center w-75 me-md-auto ms-md-auto">
          {description}
        </p>

        <div className="row">
          {feature1 && <Feature feature={feature1} />}
          {feature2 && <Feature feature={feature2} />}
          {feature3 && <Feature feature={feature3} />}
          {feature4 && <Feature feature={feature4} />}
          {feature5 && <Feature feature={feature5} />}
          {feature6 && <Feature feature={feature6} />}
        </div>
      </div>
    </div>
  )
}

export default AddOns

const Feature = ({ feature }) => (
  <div className="col-sm-12 col-md-6 col-lg-4 text-center">
    <div
      className={styles.add_on}
      dangerouslySetInnerHTML={{ __html: feature }}
    />
  </div>
)
